export default __webpack_public_path__ + "static/media/PC-logo.1aa32012.webp";